/*-----------------------------------------------
 共通JS
-----------------------------------------------*/
$(function(){

// ページトップへ戻るのスクロール
  var $pagetop = $('#pageTop');

  if ($(window).width() > 768) $pagetop.hide();
  $(window).scroll(function(){
    if($(window).scrollTop() > 200){
      $pagetop.fadeIn();
    } else {
      $pagetop.fadeOut();
    }
  });

  $pagetop.click(function(){
    $('html,body').animate({scrollTop:0},1000);
    return false;
  });

// アンカーリンクを押すと、スクロール
  $('a[href^=#]:not([class*="modal"])').click(function() {
      var speed = 400;
      var href= $(this).attr("href");
      var target = $(href == "#" || href == "" ? 'html' : href);
      var headerH = $('#hwrap').innerHeight();
      var position = target.offset().top;
      $('body,html').animate({scrollTop:position-headerH}, speed, 'swing');
      return false;
  });

});

//メニュー
$(function() {
    var $header = $('#top-head');
    // Nav Fixed
    $(window).scroll(function() {
        if ($(window).scrollTop() > 350) {
            $header.addClass('fixed');
        } else {
            $header.removeClass('fixed');
        }
    });
    // Nav Toggle Button
    $('#nav-toggle').click(function(){
        $header.toggleClass('open');
    });
});

var activeClassName = 'active';
var regex = new RegExp(/index\.(html|php)/);
var path = location.pathname.replace(regex, '');

var HeaderLinks = $('header nav').find('a');
var SidebarLinks = $('#sidebar').find('a');

HeaderLinks.each(function() {
	var parser = document.createElement('a');
	parser.href = $(this).attr('href').replace(regex, '');
	var locationPath = parser.pathname;
	locationPath = locationPath.indexOf('/') == 0 ? locationPath : '/' + locationPath;
	//繧ｰ繝ｭ繝ｼ繝舌Ν縺ｯ蜑肴婿荳閾ｴ縺ｧ
	if (locationPath == "/") {
		if(locationPath == path) $(this).addClass(activeClassName);
	} else if(path.indexOf(locationPath) != -1){
		$(this).addClass(activeClassName);
	}
});

// URLと同じリンク先だったらサイドナビのliにクラスを付与
$(function(){
	$('#sidenav ul li a').each(function(){
		var $href = $(this).attr('href') + '\$';
			if(location.href.match($href)) {
				$(this).addClass('current');
			} else {
				$(this).removeClass('current');
			}
		});
});
